/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Tag_CitationInputs */

const en_why_listening_tag_citation = /** @type {(inputs: Why_Listening_Tag_CitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citation skipped`)
};

const es_why_listening_tag_citation = /** @type {(inputs: Why_Listening_Tag_CitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cita omitida`)
};

/**
* | output |
* | --- |
* | "Citation skipped" |
*
* @param {Why_Listening_Tag_CitationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_tag_citation = /** @type {((inputs?: Why_Listening_Tag_CitationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Tag_CitationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_tag_citation(inputs)
	return en_why_listening_tag_citation(inputs)
});